import type { ChangeEvent, ReactElement } from 'react'

type Props = {
  searchData: Frontend.SearchData
} & TranslateProps

export default function SearchSortingForm({ t, searchData }: Readonly<Props>): ReactElement {
  const handleSortingChange = (event: ChangeEvent<HTMLSelectElement>) => {
    searchData.updateSorting(event.target.value)
    if (typeof window !== 'undefined') {
      window.scrollTo({ top: 0, behavior: 'smooth' })
    }
  }

  return (
    <label className="sorting-dropdown">
      <span>{t('components.productListComponent.sortingDropdown.label')}</span>
      <select value={searchData.sortings.find((s) => s.active)?.sorting} onChange={handleSortingChange}>
        {searchData.sortings.map((sorting) => (
          <option value={sorting.sorting} key={sorting.label}>
            {t('components.productListComponent.sortingDropdown.options.' + sorting.label)}
          </option>
        ))}
      </select>
    </label>
  )
}
